// The server can add these after a message was first stored, e.g. by echoing it
// back or by a 'message_updated' event.
const SERVER_FIELDS = ['text', 'controls'];

// A document's page previews are server links rebuilt from their key, so an inline
// copy of the image is not stored: a few pages of base64 would fill localStorage.
export const storedDocumentPreviews = (images) =>
  images.map((im) => (im?.key ? { ...im, base64: undefined, src: undefined, url: undefined } : im));

const documentPreviews = (msg) =>
  msg.typeOfMedia === 'file' &&
  Array.isArray(msg.images) &&
  msg.images.length > 0 &&
  msg.images.every((im) => im?.key)
    ? storedDocumentPreviews(msg.images)
    : undefined;

export const mergeStoredMessage = (cached, live) => {
  const merged = { ...cached };

  if (Array.isArray(live.reactions)) {
    merged.reactions = live.reactions;
  }
  merged.deliveryStatus = live.deliveryStatus;
  merged.deliveryRejection = live.deliveryRejection;
  merged.timestamp = live.timestamp;

  for (const field of SERVER_FIELDS) {
    if (live[field] !== undefined) merged[field] = live[field];
  }

  const previews = documentPreviews(live);
  if (previews) merged.images = previews;

  return merged;
};
